module.exports = __webpack_public_path__ + "static/media/xiaomi_autostart_1.815c961f.jpg";